export default {
  guide: {
    start: 'Inizia',
    whatsNext: 'Cosa c’è dopo?',
    dontShowAgain: 'Non mostrare più questo popup',
    needHelp: 'Hai bisogno di aiuto?',
    userManual: 'Manuale utente',
    chooseFormat: 'Scegli il formato che preferisci',
    pdfManual: 'Manuale PDF',
    downloadPdf: 'Scarica e leggi offline',
    videoTutorial: 'Tutorial video',
    watchStepByStep: 'Guarda la guida passo dopo passo',
    firstStepTitle: 'Benvenuto! Ti guideremo attraverso i tuoi primi passi.',
    activationKey: {
      title: 'Le nuove chiavi di attivazione sono state registrate con successo.',
      description:
        'Invia le chiavi di attivazione agli agricoltori/raccoglitori di dati affinché possano registrarsi sotto la tua organizzazione.',
      nextStep: 'Fai clic sul pulsante Azione per selezionare il formato con cui desideri condividere le chiavi.',
    },
    dashboard: {
      userManagement: 'Gestione utenti',
      userManagementDescription: 'La sezione Gestione utenti ti consente di:',
      listUser: 'Visualizzare l’elenco attuale degli utenti mobile e admin',
      addUser: 'Aggiungere nuovi utenti o invitare utenti con chiavi di attivazione',
      managePermission: 'Gestire permessi, piani di abbonamento e ruoli',
      farmManagement: 'Gestione delle aziende agricole',
      farmManagementDescription: 'Vai alla sezione Gestione delle aziende agricole per:',
      listFarm: 'Visualizzare l’elenco delle aziende agricole e degli agricoltori registrati',
      addFarm: 'Aggiungere nuove aziende agricole una per una o in blocco',
      title: 'Dashboard',
      description:
        'Man mano che integri più utenti e aziende agricole, potrai vedere il riepilogo nella dashboard principale.',
    },
    ddsDashboard: {
      title: 'Inizia dalla sezione “Crea un nuovo rapporto di due diligence” per cominciare.',
      alreadyHaveFarm: 'Hai già i dati dell’azienda agricola?',
      description:
        'Avrai la possibilità di aggiungere i dati della tua azienda agricola durante il secondo passaggio del processo "Crea un nuovo rapporto di due diligence".',
      createNewReport: 'Crea nuovo rapporto',
      creatingReport: 'Creazione di un rapporto di due diligence',
      sharingWithOperator: 'Condivisione con l’operatore',
      riskMitigation: 'Mitigazione del rischio',
    },
    productionPlace: {
      title: 'Carica i dati della tua azienda agricola',
      description: 'Carica i dati della tua azienda agricola uno per uno o in blocco facendo clic sul pulsante "Aggiungi nuovo".',
      allowedFormat: 'Attualmente accettiamo i seguenti formati per il caricamento dei dati in blocco:',
    },
    reportDetail: {
      title: 'Per prima cosa, compila i dettagli relativi al tuo rapporto.',
      description: 'Hai bisogno di aiuto? Consulta le nostre guide utente (PDF o video) facendo clic qui:',
      nextStep: 'Una volta completato, fai clic su "Avanti" per procedere al passaggio in cui potrai caricare i dati di produzione della tua azienda agricola.',
    },
    adminRegistered: {
      title: 'Il nuovo utente amministratore è stato registrato con successo.',
      description:
        'Invia le chiavi di attivazione agli agricoltori/raccoglitori di dati affinché possano registrarsi sotto la tua organizzazione.',
      nextStep: 'Cosa c’è dopo? Inizia a integrare agricoltori e raccoglitori di dati.',
    },
  },
};
